export const OFFERS_CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
export const DISPLAY_CATEGORIES_CACHE_TTL_MS = OFFERS_CACHE_TTL_MS;

/** Keep at most this many distinct geo-filtered offer entries on disk. */
export const OFFERS_CACHE_MAX_GEO_ENTRIES = 5;

/**
 * Number of decimal places kept on `latitude`/`longitude` when computing the cache key.
 * 2 decimals ≈ 0.01° ≈ 1.1 km at the equator: coarse enough that GPS jitter doesn't
 * fragment the cache, fine enough that the cached search center stays close to the
 * user's actual position.
 */
export const GEO_BUCKET_PRECISION = 2;

export const OFFERS_QUERY_KEY_PREFIX = 'offers_query::';
export const DISPLAY_CATEGORIES_QUERY_KEY = 'display_categories_query';
